import React from "react"
import styles from "./FormField.module.css"
import { FormFieldProps } from "./types"

export const FormField = ({
    label,
    placeholder,
    value,
    onChange,
    onBlur,
    isInputType,
    disabled,
    maxLength,
    onKeyDown,
}: FormFieldProps) => {
    return (
        <div>
            <p className={styles.description}>{label}</p>
            <div className={styles.textinput}>
                <input
                    placeholder={placeholder}
                    type={isInputType ? isInputType : "text"}
                    className={`${styles.input} ${disabled ? styles.disabled : ""}`}
                    value={value}
                    onChange={e => onChange(e.target.value)}
                    onBlur={onBlur}
                    disabled={disabled}
                    maxLength={maxLength}
                    onKeyDown={onKeyDown}
                />
            </div>
        </div>
    )
}
